import '@gjensidige/builders-fonts/dist/fonts.css'; // Remember to include fonts
import '@gjensidige/core-navigation/dist/style.css'; // Remember to also import styling

import React from 'react';
import { Nav } from '@gjensidige/core-navigation';

import { NavContent } from './components/NavContent';
import NavDesktop from './components/NavDesktop';
import { NavUser } from './components/NavUser';

import styles from './index.module.less';

const NciNavigation = () => {
  return (
    <div className={styles.navHeight}>
      <Nav
        isLoggedIn
        language="da"
        skipId="content"
        className={styles.loggedinNavigation}
        systemMessages={window.systemMessages ?? '/api-builders/system-messages'}
        systemMessagesFilter={{ application: window.appName }}
        badge={0}
        cookieConsent={false}
      >
        <NavDesktop />
        <NavUser />
        <NavContent />
      </Nav>
    </div>
  );
};

export default NciNavigation;
